/** Rótulo padrão do menu (mesma fonte que GestaoVagasModulo.php / painel). */
export const GV_ROTULO_MENU_PADRAO_PLURAL = "Gestão de vagas"
export const GV_ROTULO_MENU_PADRAO_SINGULAR = "Gestão de vaga"

function aplicarCase(origem, destino) {
	const alvo = String(destino ?? "")
	if (!alvo) return alvo
	const src = String(origem ?? "")
	if (src === src.toUpperCase()) return alvo.toUpperCase()
	if (src[0] === src[0]?.toUpperCase()) {
		return alvo.charAt(0).toUpperCase() + alvo.slice(1)
	}
	return alvo.toLowerCase()
}

/**
 * Resolve singular/plural a partir do rótulo configurado no painel (rotuloMenu).
 * @param {string} rotuloMenu
 */
export function resolverRotulosGestaoVaga(rotuloMenu) {
	const plural = String(rotuloMenu ?? "").trim() || GV_ROTULO_MENU_PADRAO_PLURAL
	const singular = plural.endsWith("s") ? plural.slice(0, -1) : plural
	const palavras = plural.split(/\s+/).filter(Boolean)
	const pluralCurto = palavras[palavras.length - 1] || plural
	const singularCurto = pluralCurto.endsWith("s")
		? pluralCurto.slice(0, -1)
		: pluralCurto

	return { plural, singular, pluralCurto, singularCurto }
}

/**
 * Substitui «vaga»/«vagas» e «Gestão de vaga(s)» pelo rótulo configurado.
 * Mantém capitalização aproximada do texto original.
 */
export function aplicarRotuloVagaTexto(texto, rotulos) {
	if (texto == null || texto === "") return texto
	if (typeof texto !== "string") return texto

	const { plural, singular, pluralCurto, singularCurto } =
		rotulos ?? resolverRotulosGestaoVaga()

	let out = texto
	out = out.replace(/Gestão de vagas/gi, (m) => aplicarCase(m, plural))
	out = out.replace(/Gestão de vaga/gi, (m) => aplicarCase(m, singular))
	out = out.replace(/\bvagas\b/gi, (m) => aplicarCase(m, pluralCurto))
	out = out.replace(/\bvaga\b/gi, (m) => aplicarCase(m, singularCurto))

	return out
}

/** Atalho: texto com rótulo do menu configurado. */
export function txtRotuloVaga(texto, rotuloMenu) {
	return aplicarRotuloVagaTexto(texto, resolverRotulosGestaoVaga(rotuloMenu))
}
